import { Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types'
import styles from './LoadingOverlay.module.css'

/**
 * Full-screen loading overlay with spinner and optional message.
 * Use for blocking operations like save/submit.
 */
export const LoadingOverlay = ({ isVisible, message }) => {
  if (!isVisible) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <Spinner animation="border" role="status" variant="primary" className={styles.spinner} />
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  )
}

LoadingOverlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.string,
}

LoadingOverlay.defaultProps = {
  message: null,
}

export default LoadingOverlay
